import { territoriesSlice } from "./territoriesSlice";
import * as defaultActions from "../../../../../redux/_common";
import { IQueryParams } from "../../../../common/interfaces/API";

const { actions } = territoriesSlice;

export const moduleUrl = "/api/appmasterdata/territories"

export const QPARAMS_CHANGED = "territories/QParamsChanged";

export const setValidationErrors = actions.setValidationErrors;
// export const setValidationErrors = () => defaultActions.setValidationErrors(actions);

export const getItemForEdit = (id: string) => defaultActions.getItem(`${moduleUrl}/${id}`, actions);
export const getItems = (params:IQueryParams) => defaultActions.getItems(moduleUrl, actions, params);
export const getDropDownItems = (params: {}) => defaultActions.getDropDownItems(`${moduleUrl}/select`, actions, params);
export const deleteItem = (id: string) => defaultActions.deleteItem(`${moduleUrl}/${id}`, actions);
export const saveItem = (item: {}, id: string | null) =>
  defaultActions.saveItem(
      moduleUrl,
      actions,
      item,
      id,
  );

export const clearItem = () => defaultActions.clearItem(actions);
export const clear = () => defaultActions.clearAll(actions);
export const clearError = () => defaultActions.clearErrors(actions);
